export const ROUTE_ROOT = '/';
export const ROUTE_ADD_RX = '/add-rx';
export const ROUTE_UPLOAD_READING = '/upload-reading';
